import * as XLSX from "xlsx";

export const readExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const fileName = file.name.toLowerCase();
    const isExcelXLSX = fileName.endsWith(".xlsx");
    const isExcelXLS = fileName.endsWith(".xls");
    const isCSV = fileName.endsWith(".csv");

    if (!isExcelXLSX && !isExcelXLS && !isCSV) {
      reject(new Error("Please upload a valid Excel or CSV file."));
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        let jsonData = [];
        let workbook;

        if (isExcelXLSX || isExcelXLS) {
          const data = new Uint8Array(event.target.result);
          workbook = XLSX.read(data, { type: "array" });
        } else if (isCSV) {
          const text = event.target.result;
          workbook = XLSX.read(text, { type: "string" });
        }

        const sheetName = workbook.SheetNames[0];
        if (!sheetName) {
          reject(new Error("The uploaded file has no sheets."));
          return;
        }

        const worksheet = workbook.Sheets[sheetName];
        jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (!jsonData.length) {
          reject(new Error("The file is empty or has invalid format."));
          return;
        }

        // Transform the data to match our table structure
        const transformedData = jsonData.map((row, index) => ({
          id: index + 1,
          testCaseId: row["Test Case ID"] || row["testCaseId"] || `TC${String(index + 1).padStart(3, '0')}`,
          title: row["Test Case Title"] || row["title"] || row["Test Case Name"] || "Untitled Test Case",
          testSteps: row["Test Steps"] || row["testSteps"] || row["Steps"] || "No steps defined",
          expectedResult: row["Expected Result"] || row["expectedResult"] || row["Expected"] || "No expected result defined",
          moduleName: row["Module Name"] || row["moduleName"] || row["Module"] || "General",
          priority: row["Priority"] || row["priority"] || "Medium",
          remarks: row["Remarks"] || row["remarks"] || row["Notes"] || row["Comments"] || "",
        }));

        resolve(transformedData);
      } catch (error) {
        reject(new Error("Error reading file: " + error.message));
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read the file. Please try again."));
    };

    if (isExcelXLSX || isExcelXLS) {
      reader.readAsArrayBuffer(file);
    } else if (isCSV) {
      reader.readAsText(file);
    }
  });
};

export const validateFileFormat = (file) => {
  const fileName = file.name.toLowerCase();
  const isExcelXLSX = fileName.endsWith(".xlsx");
  const isExcelXLS = fileName.endsWith(".xls");
  const isCSV = fileName.endsWith(".csv");
  
  return {
    isValid: isExcelXLSX || isExcelXLS || isCSV,
    fileType: isExcelXLSX ? "xlsx" : isExcelXLS ? "xls" : isCSV ? "csv" : "unknown"
  };
};
